import { render, staticRenderFns } from "./FeaturedMovies.vue?vue&type=template&id=645edd53&scoped=true&"
import script from "./FeaturedMovies.vue?vue&type=script&lang=js&"
export * from "./FeaturedMovies.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedMovies.vue?vue&type=style&index=0&id=645edd53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645edd53",
  null
  
)

export default component.exports